export const getMerchantBudgetById = (merchantBudgets, id) => {
    const selectedKey = `merchant.${id}`;
    return merchantBudgets.find((budget) => budget.key === selectedKey);
};
